(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function(){
  var drawer = document.querySelector('[data-cart-drawer]');
  if(!drawer) return;
  var itemsEl = drawer.querySelector('[data-cd-items]');
  var countEl = drawer.querySelector('[data-cd-count]');
  var subEl = drawer.querySelector('[data-cd-subtotal]');
  var footEl = drawer.querySelector('[data-cd-foot]');
  var emptyEl = drawer.querySelector('[data-cd-empty]');
  var headerCount = document.querySelector('[data-cart-count]');

  function money(c){ return '$' + (c/100).toFixed(2); }
  function esc(s){ return (s == null ? '' : String(s)).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;'); }
  function sized(url, w){ if(!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function open(){ drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; }
  function close(){ drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); document.body.style.overflow=''; }
  function syncHeader(count){ if(headerCount){ headerCount.textContent = count; headerCount.classList.toggle('is-visible', count > 0); } }

  function render(cart){
    var n = cart.item_count;
    countEl.textContent = '(' + n + ' item' + (n === 1 ? '' : 's') + ')';
    syncHeader(n);
    if(n === 0){ itemsEl.innerHTML=''; emptyEl.hidden=false; footEl.hidden=true; return; }
    emptyEl.hidden=true; footEl.hidden=false;
    var html = '';
    cart.items.forEach(function(it){
      var img = it.image ? '<img src="'+sized(it.image, 160)+'" alt="'+esc(it.product_title)+'" loading="lazy">' : '';
      html += '<div class="cd__item" data-key="'+esc(it.key)+'">'
        + '<a class="cd__thumb" href="'+esc(it.url)+'">'+img+'</a>'
        + '<div class="cd__info">'
        +   '<h3 class="cd__name"><a href="'+esc(it.url)+'" style="color:inherit;">'+esc(it.product_title)+'</a></h3>'
        +   (it.variant_title && it.variant_title !== 'Default Title' ? '<p class="cd__variant">'+esc(it.variant_title)+'</p>' : '')
        +   '<div class="cd__qty"><button type="button" class="cd__q" data-cd-dec aria-label="Decrease quantity">&minus;</button><span class="cd__qn">'+it.quantity+'</span><button type="button" class="cd__q" data-cd-inc aria-label="Increase quantity">+</button></div>'
        + '</div>'
        + '<div class="cd__right"><p class="cd__line">'+money(it.final_line_price)+'</p><button type="button" class="cd__remove" data-cd-remove>Remove</button></div>'
        + '</div>';
    });
    itemsEl.innerHTML = html;
    subEl.textContent = money(cart.total_price);
  }

  function getCart(){ return fetch('/cart.js', { headers: { 'Accept':'application/json' } }).then(function(r){ return r.json(); }); }
  function refresh(){ return getCart().then(render); }
  function change(key, qty){
    return fetch('/cart/change.js', { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function(r){ return r.json(); }).then(render);
  }

  var trigger = document.querySelector('.site-header__cart');
  if(trigger){ trigger.addEventListener('click', function(e){ e.preventDefault(); refresh().then(open); }); }

  drawer.querySelectorAll('[data-cd-close]').forEach(function(b){ b.addEventListener('click', close); });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') close(); });

  itemsEl.addEventListener('click', function(e){
    var item = e.target.closest('.cd__item'); if(!item) return;
    var key = item.getAttribute('data-key');
    var cur = parseInt(item.querySelector('.cd__qn').textContent, 10) || 1;
    if(e.target.closest('[data-cd-inc]')) change(key, cur + 1);
    else if(e.target.closest('[data-cd-dec]')) change(key, Math.max(0, cur - 1));
    else if(e.target.closest('[data-cd-remove]')) change(key, 0);
  });

  document.addEventListener('submit', function(e){
    var form = e.target.closest('form[action*="/cart/add"]');
    if(!form) return;
    e.preventDefault();
    var btn = form.querySelector('[name="add"]');
    if(btn) btn.disabled = true;
    fetch('/cart/add.js', { method:'POST', headers:{ 'Accept':'application/json' }, body: new FormData(form) })
      .then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function(){ return refresh(); })
      .then(open)
      .catch(function(){ form.submit(); })
      .then(function(){ if(btn) btn.disabled = false; });
  });

  getCart().then(function(c){ syncHeader(c.item_count); });
})();
  } catch(e) { console.error(e); }
})();

})();
